module.exports = __webpack_public_path__ + "img/logo-icon.8053d6fa.png";